var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPenalty48Filled = function SvgIconPenalty48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.05H10v3.4h18v-3.4ZM39.2 31.53l-8.69-8.7 3.6-3.6.92.92 2.4-2.41-9.19-9.19-2.4 2.4.92.92-9.62 9.62-.92-.92-2.4 2.4 9.19 9.2 2.4-2.41-.92-.92 3.61-3.6 8.7 8.69 2.4-2.4Z",
    fill: "current"
  })));
};
export default SvgIconPenalty48Filled;